import React from "react";
import HorizontalBarChart from "./HorizontalBarChart";

type DataProps = {
  _id: string;
  title: string;
  count: number;
};

interface BarChartWidgetProps {
  data: DataProps[];
  title: string;
  metric?: string; // e.g., "views", "completions"
}

const BarChartWidget: React.FC<BarChartWidgetProps> = ({
  data,
  title,
  metric = "views",
}) => {
  const sortedData = [...data].sort((a, b) => b.count - a.count);
  const mostViewed = sortedData.slice(0, 5);
  const leastViewed = sortedData.slice(-5).reverse();

  const getMetricLabel = () => {
    if (metric === "views") return "Viewed";
    if (metric === "errors") return "Reported";
    return "Completed";
  };

  return (
    <div className="flex flex-col gap-2 p-5 w-full border-2 border-gray-200 rounded-lg overflow-hidden">
      <h3 className="text-center m-0 mb-3 text-gray-700 text-lg underline">
        {title}
      </h3>
      <div className="flex flex-col md:flex-row gap-5 w-full">
        <div className="bg-gray-100 rounded-lg p-4 shadow-sm flex-1 min-w-0 max-w-full">
          <h3 className="m-0 mb-3 text-gray-700 text-base">
            Most {getMetricLabel()} {title}
          </h3>
          {mostViewed.map((item) => (
            <div
              key={item._id}
              className="flex text-sm justify-between items-center py-2 border-b border-gray-200 last:border-b-0"
            >
              <span className="flex-1 mr-3 overflow-hidden text-ellipsis whitespace-nowrap min-w-0">
                {item.title}
              </span>
              <span className="text-gray-600 font-medium whitespace-nowrap flex-shrink-0">
                {item.count} {metric}
              </span>
            </div>
          ))}
        </div>

        <div className="bg-gray-100 rounded-lg p-4 shadow-sm flex-1 min-w-0 max-w-full">
          <h3 className="m-0 mb-3 text-gray-700 text-base">
            Least {getMetricLabel()} {title}
          </h3>
          {leastViewed.map((item) => (
            <div
              key={item._id}
              className="flex text-sm justify-between items-center py-2 border-b border-gray-200 last:border-b-0"
            >
              <span className="flex-1 mr-3 overflow-hidden text-ellipsis whitespace-nowrap min-w-0">
                {item.title}
              </span>
              <span className="text-gray-600 font-medium whitespace-nowrap flex-shrink-0">
                {item.count} {metric}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="w-full max-w-full overflow-auto">
        <HorizontalBarChart data={data} title={title} metric={metric} />
      </div>
    </div>
  );
};

export default BarChartWidget;
